module.exports = __webpack_public_path__ + "img/nick_profile.80d60bce.png";